export function pluralizeToolType(toolType: string, count: number): string {
  if (count === 1) return toolType

  return /(ch|sh|s|x)$/i.test(toolType)
    ? `${toolType}es`
    : `${toolType}s`
}
